// extracted by mini-css-extract-plugin
export default {"socialMedias-container":"ProfileSocialMedias_socialMedias-container__C4C88"};